import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-roster-page',
  templateUrl: './modify-roster-page.component.html',
  styleUrls: ['./modify-roster-page.component.css']
})
export class ModifyRosterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
